import { ampersandList } from "@edgetier/client-components";
import { createMessageSourceFromPhraseTrigger } from "utilities-for/phrase-triggers/create-message-source-from-phrase-trigger";
import { FunctionComponent, memo } from "react";
import { IProps } from "./message-sources-summary.types";
import "./message-sources-summary.scss";

/**
 * Summarise the message source options for a given phrase trigger.
 * @param props.phraseTrigger Phrase trigger being summarised.
 * @returns                   Summary of phrase trigger's message sources.
 */
const MessageSourcesSummary: FunctionComponent<IProps> = ({ phraseTrigger }) => {
    const messageSource = createMessageSourceFromPhraseTrigger(phraseTrigger);
    if (messageSource.length < 3) {
        return <>{ampersandList(createMessageSourceFromPhraseTrigger(phraseTrigger), { sort: true })}</>;
    }
    return <>All</>;
};

export default memo(MessageSourcesSummary);
